import { Injectable } from '@angular/core';
import idb from 'idb';

import { Observable, Subject } from 'rxjs';
//import { genericMD } from '../model/masterdata/masterdata';
import { GenericDD } from '../model/generic-data';
import { CryptHelperService } from './helpers/crypt-helper.service';

@Injectable({
	providedIn: 'root',
})

export class IdbService {
	private _dataChange: Subject<any> = new Subject<any>();
	private _dbPromise: any;

	constructor(private crypter: CryptHelperService) {

	}

	connectToIDB(dbName: string, ObjList: Array<string>, version: number) {
		this._dbPromise = idb.open(dbName, version, UpgradeDB => {
			ObjList.map(el => {
				if (!UpgradeDB.objectStoreNames.contains(el)) {
					UpgradeDB.createObjectStore(el, { keyPath: ['code'], autoIncrement: false });
				}
			});
		});
	}

	addItemRow(target: string, value: any,code:string,){
		this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			tx.objectStore(target).put({
				code:code,
				item: value,
			});
			return tx.complete;
		});
	}

	fetchData(item:any) {
		this._dbPromise.then((db: any) => {
			const tx = db.transaction('Fetch', 'readwrite');
			tx.objectStore('Fetch').put({
				code:'1',
				item: item,
			});
			this.getAllData('Fetch').then((targetResponde: any) => {
				this._dataChange.next(targetResponde);
			});
			return tx.complete;
		});
	}

	getLastFetch( ) {
		return this.getItemRow('Fetch','1')
	}


	

	addItems(target: string, values: Array<any>):boolean {
		this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			values.forEach((value, index) => {
				tx.objectStore(target).put({
					code:value.id,
					item: value,

				});
			});
			return tx.complete;
		});

		return true;
	}

	getItemRow(target: string, key: string) {
		return this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			const store = tx.objectStore(target);
			return store.get([key]);
		});
	}

	updateItemRow(target: string, value: any, code: string) {
		this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			const store = tx.objectStore(target);
			store.put(value, [code]);
			this.getAllData(target).then((row: any) => {
				this._dataChange.next(row);
			});
			return tx.complete;
		});
	}

	deleteItemRow(target: string, key: string) {
		this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			const store = tx.objectStore(target);
			store.delete([key]);
			this.getAllData(target).then((row: any) => {
				this._dataChange.next(row);
			});
			return tx.complete;
		});
	}

	getAllData(target: string) {
		return this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readonly');
			const store = tx.objectStore(target);
			return store.getAll();
		});
	}

	getAllDataCount(target: string) {
		return this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readonly');
			const store = tx.objectStore(target);
			return store.count();
		});
	}

	deleteAllData(target: string) {
		return this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			const store = tx.objectStore(target);
			store.clear();
			this.getAllData(target).then((row: any) => {
				this._dataChange.next(row);
			});
			return tx.complete;
		});
	}


	dataChanged(): Observable<any> {
		return this._dataChange;
	}


	// addMasterdata(target: string, values: Array<genericMD>):boolean {
	// 	this._dbPromise.then((db: any) => {
	// 		const tx = db.transaction(target, 'readwrite');
	// 		values.forEach((value, index) => {
	// 			tx.objectStore(target).put({
	// 				code:value.codice,
	// 				item: value,

	// 			});
	// 		});
	// 		return tx.complete;
	// 	});
	// 	return true;
	// }



	addGenericDD(target: string, values: Array<GenericDD>):boolean {
		this._dbPromise.then((db: any) => {
			const tx = db.transaction(target, 'readwrite');
			values.forEach((value, index) => {
				tx.objectStore(target).put({
					code:value.codice,
					item: value,

				});
			});
			return tx.complete;
		});
		return true;
	}
}
